import { ModifyIdentity } from '@grid/models';
import { DprSubActivity } from '@shared/models/dpr';

export interface DprSubActivityGridData
  extends ModifyIdentity<DprSubActivity> {}
